import React from 'react';
import { Helmet } from 'react-helmet';

const HeaderTitle = ({ title, description }) => {

    const siteSuffix = " | Upprovall.com";

    return (
        <>
            <Helmet>
                <title>{title}{siteSuffix}</title>
                { description && <meta name="description" content={description} /> }
            </Helmet>
        </>
    );
};

export { HeaderTitle };